import React from 'react';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Img01 from '../../img/feature1-1.png'
import Img02 from '../../img/feature1-2.png'
import { Box, Container, Typography, useMediaQuery } from '@material-ui/core';
import { AiOutlineCheck } from "react-icons/ai"
import CalculatorPng from "../../img/calculator.png"
import { withNamespaces } from 'react-i18next';

const useStyles = makeStyles((theme) => ({
    // ----------------------------------------------------
    shader: {
        backgroundColor: '#e0fcea'
    },
    fontFamily: {
        fontFamily: `'Roboto', sans-serif`,
        lineHeight: 1.25
    },
    headPreTitle: {
        textAlign: "center",
        fontSize: 35,
        fontWeight: 300,
        [theme.breakpoints.down("sm")]: {
            fontSize: 20,
        },
    },
    headTitle: {
        textAlign: "center",
        fontSize: 40,
        [theme.breakpoints.down("sm")]: {
            fontSize: 25,
        },
    },
    blockGrid: {
        minHeight: 350,
    },
    contentTitle: {
        fontWeight: "bold",
        fontSize: 25,
        [theme.breakpoints.down("sm")]: {
            fontSize: 20,
        },
    },
    contentGrid: {
        flex: 1,
    },
    content: {
        [theme.breakpoints.down("sm")]: {
            fontSize: 15,
        },
    },
    CalculatorTitle: {
        textAlign: "center",
        fontSize: 30
    },
    CalculatorSubTitle: {
        textAlign: "center",
        fontSize: 25
    },
    pt20: {
        paddingTop: 20
    }
}));

function StandardizeProductReportCard({ t }) {
    const theme = useTheme();
    const classes = useStyles();
    const themeMainColor = theme.palette.primary.main
    let IsOverMd = useMediaQuery(theme.breakpoints.up('md'))


    const ContentLine = ({ content }) => {
        return (
            <Grid item>
                <Grid item container xs={12} direction="row" alignItems="center" style={{ paddingTop: 20 }}>
                    <Grid style={{ paddingRight: 20 }}>
                        <AiOutlineCheck size={30} color={themeMainColor} />
                    </Grid>
                    <Grid item container className={classes.contentGrid}>
                        <Typography className={classes.content}>
                            {content}
                        </Typography>
                    </Grid>
                </Grid>
            </Grid>
        )
    }

    return (
        <Grid className={classes.fontFamily}>
            <Grid>
                <Box p={10} />
                <h1 className={classes.headPreTitle} style={{ textDecoration: "underline", textDecorationColor: themeMainColor }}>
                    {t("standardize-product-card")}
                </h1>
                <h2 className={classes.headTitle}>
                    {t("why-myLife-platform-for-protection")}
                </h2>
            </Grid>
            <Container>
                <Grid container item direction="row" alignItems="center" >
                    <Grid item md={6} xs={12}>
                        <img src={Img01} alt="img01"
                            style={{
                                width: "55%",
                                marginLeft: "auto",
                                marginRight: "auto",
                                display: "block"
                            }}
                        />
                    </Grid>
                    <Grid item md={6} xs={12}>
                        <Grid item container direction="column" className={classes.blockGrid}>
                            <Grid item>
                                <Typography className={classes.contentTitle}>
                                    {t("product-comparsion")}
                                </Typography>
                            </Grid>
                            <ContentLine content={t("various-type")} />
                            <ContentLine content={t("ai-simulated")} />
                            <ContentLine content={t("key-performance")} />
                            <ContentLine content={t("side-by-side")} />
                            <ContentLine content={t("interactive-value")} />
                        </Grid>
                    </Grid>
                </Grid>
            </Container>
            <Grid className={classes.shader} style={{ paddingTop: 30, paddingBottom: 30 }}>
                <Container>
                    <Grid container item direction="row" alignItems="center">
                        {
                            !IsOverMd
                            &&
                            <Grid item md={6} xs={12}>
                                <img src={Img02} alt="img02"
                                    style={{
                                        width: "55%",
                                        marginLeft: "auto",
                                        marginRight: "auto",
                                        display: "block"
                                    }}
                                />
                            </Grid>
                        }
                        <Grid item container md={6} xs={12} direction="column" className={classes.blockGrid}>
                            <Grid item>
                                <Typography className={classes.contentTitle}>
                                    {t("high-accuracy")}
                                </Typography>
                            </Grid>
                            <ContentLine content={t("interactive-value-illustration")} />
                            <ContentLine content={t("key-performance-index")} />
                            <ContentLine content={t("charting-for")} />
                            <ContentLine content={t("streamline")} />
                            <ContentLine content={t("digitalize-info")} />
                        </Grid>
                        {
                            IsOverMd
                            &&
                            <Grid item md={6} xs={12}>
                                <img src={Img02} alt="img02"
                                    style={{
                                        width: "55%",
                                        marginLeft: "auto",
                                        marginRight: "auto",
                                        display: "block"
                                    }} 
                                />
                            </Grid>
                        }
                    </Grid>
                </Container>
            </Grid>
            <Container>
                <Grid container item direction="row" alignItems="flex-end">
                    <Grid item md={6} xs={12}>
                        <img src={CalculatorPng} alt="calculator"
                            style={{
                                width: "55%",
                                marginLeft: "auto",
                                marginRight: "auto",
                                display: "block"
                            }}
                        />
                    </Grid>
                    <Grid item container md={6} xs={12} direction="column" className={classes.blockGrid}>
                        <Grid item>
                            <Typography className={classes.contentTitle}>
                                {t("life-protection-calculator")}
                            </Typography>
                        </Grid>
                        <Typography className={classes.pt20}>
                            {t("how-much-coverage")}
                        </Typography>
                        <Typography className={classes.pt20}>
                            {t("you-can-enter")}
                        </Typography>

                    </Grid>
                </Grid>
            </Container>
        </Grid>
    );
}
export default withNamespaces()(StandardizeProductReportCard)